export default "__VITE_ASSET__CUpZfJIU__"